import { createReducer, on } from '@ngrx/store';
import { initialTenantState } from './tenant.state';
import * as TenantActions from './tenant.actions';
import * as AuthActions from '../auth/auth.actions';

export const tenantReducer = createReducer(
  initialTenantState,

  on(TenantActions.loadCurrentTenantSuccess, (state, { tenant }) => ({
    ...state,
    currentTenant: tenant,
    loading: false,
    error: null,
  })),

  on(TenantActions.loadCurrentTenantFailure, (state, { error }) => ({
    ...state,
    currentTenant: null,
    loading: false,
    error,
  })),

  on(TenantActions.clearCurrentTenant, (state) => ({
    ...state,
    currentTenant: null,
    error: null,
  })),

  on(AuthActions.logout, () => initialTenantState)
);
